import { defineComponent } from "../../../common/runtime/defineComponent.svelte.ts";
import { iconRegistryStyles } from "../../../scss/icon/iconRegistryStyles.ts";
import component from "./ChipV3.svelte";

defineComponent({
  tag: "oc-chip-v3",
  extendOptions: { useOcAutoAriaLabel: true },
  styles: [iconRegistryStyles, () => import("./ChipV3.global.scss?inline")],
  props: {
    useCheckStateIcon: {
      type: "Boolean",
      attribute: "use-check-state-icon",
      reflect: true,
      default: false,
    },
    checkIfSelected: {
      type: "Boolean",
      attribute: "check-if-selected",
      reflect: true,
      default: false,
    },
    iconLeft: { type: "String", attribute: "icon-left", reflect: true },
    iconRight: { type: "String", attribute: "icon-right", reflect: true },
    overColor: { type: "Boolean", attribute: "over-color", reflect: true, default: false },
    size: { type: "String", reflect: true, default: "100" },
    widthBehavior: { type: "String", attribute: "width-behavior", reflect: true, default: "fit" },
  },
  component: () => component,
});
